import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Tooltip,
  Chip
} from '@mui/material';
import { OpenInNew, Edit, Delete } from '@mui/icons-material';

export default function SceneList({ scenes, onOpenScene, onEditMeta, onDelete }) {
  const list = scenes || [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Scene name</TableCell>
            <TableCell>Character</TableCell>
            <TableCell>Flow</TableCell>
            <TableCell align="center" sx={{ whiteSpace: 'nowrap', minWidth: 152 }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((s) => (
            <TableRow key={s._id} hover>
              <TableCell>
                <strong>{s.name}</strong>
              </TableCell>
              <TableCell>
                {s.characterId?.name ? (
                  <Chip size="small" label={s.characterId.name} variant="outlined" />
                ) : (
                  '—'
                )}
              </TableCell>
              <TableCell>
                <div
                  style={{
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {[s.flowId?.name, s.flow2Id?.name, s.flow3Id?.name].filter(Boolean).join(' · ') || '—'}
                </div>
              </TableCell>
              <TableCell align="center" sx={{ whiteSpace: 'nowrap', minWidth: 152 }}>
                <Box
                  sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.25
                  }}
                >
                  <Tooltip title="Open scene editor (16:9 layout)">
                    <IconButton onClick={() => onOpenScene(s)} color="primary" size="small" aria-label="Open scene editor">
                      <OpenInNew />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit name, character, flows">
                    <IconButton
                      onClick={() => onEditMeta?.(s)}
                      size="small"
                      aria-label="Edit scene details"
                      disabled={!onEditMeta}
                      sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary', bgcolor: 'action.hover' } }}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => onDelete(s._id)} color="error" size="small" aria-label="Delete scene">
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {list.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No scenes found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
